import TypoIntro from './TypoIntro'

export default TypoIntro
